import { useState } from 'react';
import { ColorSelector } from './ColorSelector';

export function ColorSelectorGroup({
    colors,
    items,
    disabled,
    onChange,
}) {
    const [state, setState] = useState(() => {
        const initial = {};
        items.forEach((item) => {
            initial[item.id] =
                item.value != null ? item.value : item.defaultColor;
        });
        return initial;
    });

    const updateColor = (id, color) => {
        setState((prev) => {
            const next = {
                ...prev,
                [id]: color,
            };

            onChange(next);
            return next;
        });
    };

    return (
        <div className="flex justify-start gap-4">
            {items.map((item) => (
                <div key={item.id} className="flex items-center gap-2">
                    <div>{item.label}:</div>
                    <div>
                        <ColorSelector
                            disabled={disabled}
                            defaultColor={item.defaultColor}
                            colors={colors}
                            label=""
                            selectedColor={state[item.id]}
                            onSelect={(color) => {
                                if (color) {
                                    updateColor(item.id, color);
                                }
                            }}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}